import { render, staticRenderFns } from "./LoginOld.vue?vue&type=template&id=75ed4be0&scoped=true&"
import script from "./LoginOld.vue?vue&type=script&lang=js&"
export * from "./LoginOld.vue?vue&type=script&lang=js&"
import style0 from "./LoginOld.vue?vue&type=style&index=0&id=75ed4be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ed4be0",
  null
  
)

export default component.exports